import { render, staticRenderFns } from "./ProjectManagerTable.vue?vue&type=template&id=1ebd75e2&"
import script from "./ProjectManagerTable.vue?vue&type=script&lang=ts&"
export * from "./ProjectManagerTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports